<!-- dropdown button -->
<ng-container *ngIf="isDropdownButton">
    <button *ngIf="hasAction" class="btn {{styleClass}} {{sizeClass}} {{options.item.disabled ? 'disabled' : ''}}" type="button" (click)="click($event)" sqTooltip="{{itemTitle | sqMessage:itemMessageParams}}" [attr.aria-label]="itemTitle | sqMessage:itemMessageParams">
        <sq-action-item-content [item]="options.item" [text]="itemText"></sq-action-item-content>
    </button>
    <ng-container *ngIf="options.item.flattenable && options.item.children?.length === 1; then flattened else unflattened"></ng-container>
    <ng-template #flattened>
        <div *ngIf="!hasAction" class="btn {{styleClass}} {{sizeClass}}">
            <sq-action-item-content *ngIf="!hasAction" [item]="options.item" [text]="itemText"></sq-action-item-content>
        </div>
    </ng-template>
    <ng-template #unflattened>
        <button class="btn {{styleClass}} dropdown-toggle {{sizeClass}}" type="button" data-bs-toggle="dropdown" sqTooltip="{{itemTitle | sqMessage:itemMessageParams}}" [attr.aria-label]="itemTitle | sqMessage:itemMessageParams" (touchstart)="touchstart()" (mousedown)="mousedown()" (focusin)="focusin()">
            <sq-action-item-content *ngIf="!hasAction" [item]="options.item" [text]="itemText"></sq-action-item-content>
        </button>
        <ul *ngIf="showDropdown" [sq-dropdown-menu]="dropdownMenuOptions"></ul>
    </ng-template>
</ng-container>
<!-- button -->
<sq-action-item-content *ngIf="isButton" [item]="options.item" [text]="itemText"></sq-action-item-content>
<!-- dropdown list item -->
<ng-container *ngIf="isDropdownListItem">
    <a href="javascript:void(0)" (click)="click($event)" [ngClass]="{'nav-link': options.inMenu, 'dropdown-item': !options.inMenu, 'disabled': options.item.disabled}" class="dropdown-toggle" data-bs-toggle="dropdown" role="button" title="{{itemTitle | sqMessage:itemMessageParams}}" aria-haspopup="true" aria-expanded="false" [attr.aria-label]="itemTitle | sqMessage:itemMessageParams">
        <sq-action-item-content [item]="options.item" [text]="itemText"></sq-action-item-content>
    </a>
    <ul [sq-dropdown-menu]="dropdownMenuOptions"></ul>
</ng-container>

<!-- list item -->
<a *ngIf="isListItem" href="javascript:void(0)" class="{{options.inMenu ? 'nav-link' : 'dropdown-item'}} {{options.item.disabled ? 'disabled' : ''}}" role="button" (click)="click($event)" title="{{itemTitle | sqMessage:itemMessageParams}}" [attr.aria-label]="itemTitle | sqMessage:itemMessageParams">
    <sq-action-item-content [item]="options.item" [text]="itemText"></sq-action-item-content>
</a>
